export default "__VITE_ASSET__DFU0oYr3__"